var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('image-component',{attrs:{"infoType":'banner',"infoKey":`fatherBanner`}}),_c('terms-component',{attrs:{"terms-type":'stipulation'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }